import React from 'react'
import { Link } from "react-router-dom";


const ENT = () => {
  return (
    <>
      <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
        <div className="container">
          <div className="dz-bnr-inr-entry d-table-cell">
            <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>कान, नाक और गले </h1>
            <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
              <ul className="">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item">कान, नाक और गले </li>
              </ul>
            </nav>
            <div className="dz-btn">
              <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                <span className="left-icon">
                  <i className="feather icon-phone-call" />
                </span>
                +91 9165155945
              </a>
            </div>
          </div>
        </div>
        <span className="text-vertical">24/7 आपातकालीन सेवा</span>
        <ul className="dz-social">
          <li>
            <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
              <i className="fa-brands fa-facebook-f" />
            </Link>
          </li>
          <li>
            <a to="https://www.instagram.com" target="_blank">
              <i className="fa-brands fa-instagram" />
            </a>
          </li>

          <li>
            <a to="https://twitter.com" target="_blank">
              <i className="fa-brands fa-x-twitter" />
            </a>
          </li>
          <li>
            <a to="https://www.youtube.com" target="_blank">
              <i className="fa-brands fa-youtube" />
            </a>
          </li>
        </ul>
      </div>

      <section className="content-inner" style={{ marginTop: "-10px" }}>
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/कान, नाक और गले_01.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/कान, नाक और गले_02.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/कान, नाक और गले_03.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/कान, नाक और गले_04.webp" alt="/" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="content-inner service-single">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 single-inner order-lg-1">
              <div className="single-media dz-media single-media height-sm radius-lg wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.1s', animationName: 'fadeInUp' }}>
                <img src="./assets/img/कान, नाक और गले.webp" alt className="object-fit-cover" />
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                <h2>कान, नाक और गले </h2>
                <p>हमारे अस्पताल का कान, नाक और गला  विभाग आधुनिक तकनीक और अनुभवी विशेषज्ञ डॉक्टरों की टीम के साथ समर्पित रूप से सेवाएं प्रदान करता है। हम बच्चों से लेकर बुजुर्गों तक सभी आयु वर्ग के मरीजों के लिए सुरक्षित, सटीक और प्रभावी उपचार उपलब्ध कराते हैं।</p>
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                <h3>हम इन स्थितियों का इलाज करते हैं</h3>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅   कान के रोगों का उपचार (कान बहना, सुनने में कमी, इन्फेक्शन)</li>
                  <li>  ✅   नाक संबंधी समस्याएं (साइनस, एलर्जी, नाक बंद रहना, नकसीर)</li>
                  <li>  ✅   गले के रोग (टॉन्सिल, आवाज बैठना, थायरॉयड से जुड़ी समस्याएं)</li>
                  <li>  ✅   साइनस सर्जरी और एंडोस्कोपिक सर्जरी</li>
                  <li>  ✅  टॉन्सिल और एडेनॉइड सर्जरी </li>
                  <li>  ✅  हियरिंग टेस्ट (Audiometry) और अन्य डायग्नोस्टिक सेवाएं </li>
                </ul>

                <h3>कान (Ear) की आम समस्याएं</h3>
                <b style={{ color: "black" }}>1. कान में दर्द / इन्फेक्शन (Ear Infection)</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ सुनाई कम देना (Hearing Loss)</li>
                  <li>  ✅ कान में आवाज आना (Tinnitus)</li>
                  <li>  ✅ चक्कर आना (Vertigo)</li>
                </ul>
                <b style={{ color: "black" }}>2. लक्षण</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ दर्द, बुखार</li>
                  <li>  ✅ कान से पानी आना</li>
                  <li>  ✅ सुनने में परेशानी</li>
                </ul>
                <b style={{ color: "black" }}>3. नाक (Nose) की समस्याएं</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ साइनस (Sinusitis)</li>
                  <li>  ✅ एलर्जी / जुकाम (Allergic Rhinitis)</li>
                  <li>  ✅ नकसीर (Nosebleed)</li>
                  <li>  ✅ नाक बंद रहना</li>
                </ul>
                <b style={{ color: "black" }}>4. लक्षण</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ नाक बंद / बहना</li>
                  <li>  ✅ सिर दर्द</li>
                  <li>  ✅ चेहरे में भारीपन</li>
                </ul>
                <b style={{ color: "black" }}>5. गला (Throat) की समस्याएं</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ गले में दर्द (Sore Throat / Pharyngitis)</li>
                  <li>  ✅ टॉन्सिल (Tonsillitis)</li>
                  <li>  ✅ आवाज बैठना (Laryngitis)</li>
                  <li>  ✅ निगलने में दिक्कत</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 m-b30">
              <aside className="side-bar sticky-top left">
                <div className="widget service_menu_nav bg-secondary wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                  <div className="widget-title">
                    <h4 className="title">सभी सेवाएँ</h4>
                  </div>
                  <ul>
                    <li className="active"><Link to="/ent">कान, नाक और गले</Link></li>
                    <li><Link to="/paediatrics">बाल चिकित्सा</Link></li>
                    <li><Link to="/gynaecology">प्रसूति एवं स्त्री रोग</Link></li>
                    <li ><Link to="/dental">डेंटल</Link></li>
                    <li><Link to="/general-medicine">सामान्य दवा</Link></li>
                    <li><Link to="/general-surgery">जनरल सर्जरी</Link></li>
                    <li><Link to="/orthopedic">ऑर्थोपेडिक</Link></li>
                    <li><Link to="/physiotherapy">फिजियोथेरेपी</Link></li>
                    <li ><Link to="/urology">यूरोलॉजी</Link></li>
                    <li ><Link to="/dermatology">डर्मेटोलॉजी</Link></li>
                    <li ><Link to="/pulmonology">पल्मोनोलॉजी</Link></li>
                    <li><Link to="/anaesthesiology">एनेस्थिसियोलॉजी</Link></li>
                    <li><Link to="/general-medicine">जनरल मेडिसिन</Link></li>
                  </ul>
                </div>
                <div className="widget_contact" style={{ backgroundImage: 'url(./assets/images/background/bg3.png)' }} data-wow-delay="0.4s" data-wow-duration="0.7s">
                  <div className="widget-content">
                    <img src="./assets/images/question.png" width={80} alt />
                    <h4 className="title">क्या आपको किसी मदद की ज़रूरत है?</h4>
                    <div className="phone-number">
                      <a href="tel:+919165155945">+91 9165155945</a>
                    </div>
                    <div className="email">
                      <a href="mailto:omkarmultispecialityhospital1@gmail.com">omkarmultispecialityhospital1
                        @gmail.com</a>
                    </div>
                    <div className="link-btn">
                      <a to="/contact-us" className="btn btn-lg btn-icon btn-white hover-secondary btn-shadow">
                        Contact Us <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}

export default ENT